import React from 'react'
import { Link } from 'react-router-dom'

import { Menu, Dropdown, Avatar, Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import useApp from 'useApp'
import { logout } from 'utils'
import styles from './style.module.scss'

const ProfileMenu = () => {
  const { me } = useApp()
  const doLogout = () => {
    logout()
    window.location.href = '/user/login'
  }

  const menu = (
    <Menu selectable={false}>
      <Menu.Item>
        <small>
          {me.email} {me.is_admin ? '(Admin)' : ''}
        </small>
        <h3>
          <strong>Free Plan</strong>
        </h3>
        <Link to={`/member/${me.id}`}>
          <Button type="primary" ghost>
            <FormattedMessage id="topBar.profileMenu.gotoProfile" />
          </Button>
        </Link>
      </Menu.Item>
      {/* <Menu.Divider />
      <Menu.Item>
        <a href="//settings/password">
          <i className="icon-lock" /> <FormattedMessage id="topBar.profileMenu.changePassword" />
        </a>
      </Menu.Item> */}
      <Menu.Divider />
      <Menu.Item>
        <a href="javascript: void(0);" onClick={doLogout}>
          <i className="icon-enter-right" /> <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <div className={styles.dropdown}>
        <Avatar src={me.photo_url} className={styles.avatar} shape="square" size={45} icon="user" />
      </div>
    </Dropdown>
  )
}

export default ProfileMenu
